import { Collapse } from "bootstrap"
class AnnouncementsController {
  constructor() {
    this.load()
  }

  load() {
    this.announcementPicture()
    this.loadPreviewIfCreationInProgress()
    this.selectSignaturesFromPreviousAnnouncement()
    this.listUserSearch()
    this.selectAllUsersAnnouncement()
  }

  loadPreviewIfCreationInProgress() {
    if ($(".js-preview-creation-in-progress").length > 0) {
      var url = $("#get_announcement_preview").html()
      this._loadPreviewIfNotDirty(url)
    }
  }

  listUserSearch() {
    var searchInput,
      filter,
      organizationsAccordion,
      organizationsCards,
      accordion
    searchInput = document.getElementById("js-user-search")
    if (!searchInput) {
      return
    }

    accordion = document.getElementById("accordion")
    organizationsAccordion = document.getElementById("js-announcements-users")
    organizationsCards = organizationsAccordion.getElementsByClassName(
      "js-organization-users-card"
    )

    searchInput.oninput = () => {
      // Loop through all usersRows, and hide those who don't match the search query
      filter = searchInput.value.toUpperCase()

      for (
        var cardIndex = 0;
        cardIndex < organizationsCards.length;
        cardIndex++
      ) {
        var organizationUsers =
          organizationsCards[cardIndex].getElementsByClassName("js-user-row")
        var foundUser = false
        var tabPanel =
          organizationsCards[cardIndex].querySelectorAll('[role="tabpanel"]')[0]

        for (var i = 0; i < organizationUsers.length; i++) {
          var userName = organizationUsers[i].labels[0].innerHTML
          if (userName.toUpperCase().indexOf(filter) > -1) {
            organizationUsers[i].parentNode.style.display = ""
            foundUser = true
          } else {
            organizationUsers[i].parentNode.style.display = "none"
          }
        }
        if (foundUser && filter.length != 0) {
          Collapse.getOrCreateInstance(tabPanel).show()
          //$(tabPanel).collapse("show")
        } else {
          Collapse.getOrCreateInstance(tabPanel).hide()
          //$(tabPanel).collapse("hide")
        }
      }
    }
  }

  selectSignaturesFromPreviousAnnouncement() {
    const self = this
    $(".js-auto-select-signatures a").on("click", function (e) {
      e.preventDefault()
      var signature_ids = JSON.parse($(this).attr("href"))
      var all_checks = $(
        ".announcement_candidate_signatures input[type=checkbox]"
      )
      // This line unckecks everyone before selecting the users
      // We now add the suggested users
      // all_checks.prop("checked", false)

      signature_ids.forEach(function (signature_id, index) {
        $("#announcement_candidate_signature_ids_" + signature_id).prop(
          "checked",
          true
        )
      })
      self._updateChildChecksState()
    })
  }

  selectAllUsersAnnouncement() {
    const self = this
    $(".js-checkbox-select-all").on("change", function () {
      var checked = $(this).prop("checked")
      var target = $(this).data("target")
      var child_checkboxes = $(
        ".announcement_candidate_signatures input[type=checkbox]",
        target
      )
      child_checkboxes.prop("checked", checked)

      self._updateChildChecksState()
    })

    $.each($(".js-checkbox-reflect-child-state"), () => {
      this._updateChildChecksState(true)
    })
  }

  _updateChildChecksState(init_change_status) {
    const self = this
    init_change_status =
      typeof init_change_status !== "undefined" ? init_change_status : false

    $.each($(".js-checkbox-reflect-child-state"), function () {
      var parent = $(this)
      var target = parent.data("target")

      var child_checkboxes = $(
        ".announcement_candidate_signatures input[type=checkbox]",
        target
      )

      if (init_change_status) {
        child_checkboxes.on("change", (e) => {
          self._linkNestedCheckboxState(parent, child_checkboxes)
        })
      }

      self._linkNestedCheckboxState(parent, child_checkboxes)
    })
  }

  _linkNestedCheckboxState(parent, child_checkboxes) {
    const total_checks = child_checkboxes.length
    const total_check_checked = child_checkboxes.filter(
      ":enabled" && ":checked"
    ).length

    if (!total_checks) {
      // if there's no child checkboxes, make sure "select all" is unchecked and disabled
      $(parent).prop("checked", false).prop("disabled", true)
    } else if (total_check_checked == total_checks) {
      $(parent).prop("indeterminate", false).prop("checked", true)
    } else if (total_check_checked == 0) {
      $(parent).prop("indeterminate", false).prop("checked", false)
    } else {
      $(parent).prop("indeterminate", true)
    }
  }

  _loadPreviewIfNotDirty(preview_url) {
    $.get(preview_url, (data) => {
      if (data.dirty_preview) {
        setTimeout(() => {
          this._loadPreviewIfNotDirty(preview_url)
        }, 500)
      } else {
        var url = $("#get_preview_path").text()

        if (url.length) {
          $.get(url, function (data) {
            console.log(data)

            if (data.url) {
              $(".announcement-preview.js-announcements").html(
                "<img src =" + data.url + ", height=260, width=450>"
              )
            } else {
              // document.location.reload();
            }
          })
        }
      }
    })
  }

  announcementPicture() {
    var cardPictureInput = $(".js-picture-for-contact-card")
    if (cardPictureInput.length == 0) {
      return
    }
    var full_image = cardPictureInput.data("isFullImage")
    var image_present = cardPictureInput.data("imagePresent")
    var checkbox = $($("#js_check_for_picture_contact_card")[0])
    checkbox.on("change", function () {
      if (this.checked) {
        cardPictureInput.removeClass("d-none")
      } else {
        cardPictureInput.addClass("d-none")
      }
    })
    if (full_image) {
      checkbox.prop("checked", image_present)
    } else {
      // Old signature no banner always show contact card image input
      checkbox.prop("checked", true)
      $(".js-check-for-picture-contact-card").hide()
    }
    checkbox.trigger("change")
  }
}

export { AnnouncementsController }
